/**
 * Micro Conversion
 * This file is used to push micro evetns to GTM data layer.
 *
 */

function registerEvent(eventName) {
  function handler(event) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: eventName,
        event_time: Math.floor(Date.now() / 1000),
        ecommerce: {
          detail: {
            products: event?.detail,
          },
        },
      });
    } else {
      console.warn('dataLayer not ready');
    }
  }

  window.addEventListener(eventName, handler);
}

function getPGXCookie(name) {
  const cookies = document.cookie.split('; ');
  let result = null;

  cookies.forEach((cookie) => {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      try {
        result = JSON.parse(decodeURIComponent(cookieValue));
      } catch (e) {
        result = null;
      }
    }
  });

  return result;
}

function klaviyoHandler() {
  const storedUTM = getPGXCookie('_pgx_utm_data');
  const _learnq = window._learnq || [];
  const urlVisit = window.location.href;
  // Prepare data for Klaviyo
  let klaviyoData = {
    'URL Visited': urlVisit,
  };
  // Include UTM parameters if available
  if (storedUTM) {
    klaviyoData = {...klaviyoData, ...storedUTM};
  }
  _learnq.push(['identify', klaviyoData]);
}

registerEvent('sidewall_view_items');
registerEvent('sidewall_select_item');
registerEvent('accessories_view_items');
registerEvent('accessories_select_item');
window.addEventListener('klaviyoFormSubmitted', klaviyoHandler);
